import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import {
    Colours,
    LayoutGlobals,
    ZIndex,
} from '@ratehub/base-ui';

import AdLeaderboard from './AdLeaderboard';


function AdStickyMobile({ className }) {
    return (
        <div className={className}>
            <AdLeaderboard
                overrideAdIndex="mobilesticky"
                size={{ width: 300 }} // Added the size here to force the sticky Leaderboard Ad size to 300x50 on all screen sizes (specifically nt to have it get bigger on tables)
            />
        </div>
    );
}

AdStickyMobile.propTypes = {
    className: PropTypes.string,
};

const StyledAdStickyMobile = styled(AdStickyMobile)`
    position: fixed;
    bottom: 0;
    right: 0;
    width: 100vw;
    background-color: ${Colours.STONE_LIGHTEST};
    z-index: ${ZIndex.HEADER_FOOTER};

    @media screen and (min-width: ${LayoutGlobals.STICKY_MOBILE_AD_SWITCH_WIDTH}) {
        display: none;
    }
`;

export default StyledAdStickyMobile;
